<template>
  <div class="sw" :ref="'swiper' + bannerType">
    <mt-swipe class="swiper1" :auto="7000" v-if="!list" @change="bannerChange1">
      <template v-for="(img, index) in imgs">
        <mt-swipe-item class="swiper-item" :key="index" v-if="imgs.length > 0 && (img.is_show || $isTest)"
          ><img
            class="swiper-img"
            :src="img.ad_picture.indexOf('http') < 0 ? $imgBaseSrc + img.ad_picture : img.ad_picture"
            alt=""
            @click.stop="chooseOne(img)"
          />
          <mt-swipe class="swiper" :auto="7000"></mt-swipe>
        </mt-swipe-item>
      </template>
    </mt-swipe>
    <mt-swipe
      class="swiper2"
      :auto="7000"
      v-if="list"
      @change="bannerChange2"
      :style="bannerType == 3 ? 'height:3.19rem;' : bannerType == 4 ? 'height:2rem;border-radius: 10px;' : ''"
    >
      <template v-for="(img, index) in list">
        <mt-swipe-item class="swiper-item" :key="index" v-if="img.is_show || $isTest || live">
          <img
            class="swiper-img"
            :src="img.ad_picture.indexOf('http') < 0 ? $imgBaseSrc + img.ad_picture : img.ad_picture"
            alt=""
            @click.stop="chooseOne(img)"
          />
        </mt-swipe-item>
      </template>
    </mt-swipe>
  </div>
</template>

<script>
import MaskBannerApis from '@/apis/maskservice/MaskBannerApis'

export default {
  props: {
    list: {
      type: Array
    },
    bannerType: {
      type: Number
    },
    targetUrl: {
      type: String,
      default: ''
    },
    live: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      imgs: [],
      topbanner_flge: 0,
      bannerChange_flge: 0
    }
  },
  methods: {
    chooseOne(data) {
      // 统计点击次数
      let datas = localStorage.getItem('authtoken')
      if (!datas && !window.wx) {
        this.$router.push('/user_regiter')
        return
      }

      if (window.__wxjs_environment === 'miniprogram') {
        if (this.bannerType === 6) {
          this.$toast('小程序暂不支持观看直播，请前往公众号“滇医通大专家”进行观看~')
          return
        }
      }

      if (this.live && this.$isTest) {
        this.$router.push('/new_live')
        return
      }

      if (this.live) {
        this.$router.push('/live_list')
        return
      }

      if (data.id || data.id === 0) {
        window.axiosBaseApi.put(`/v1/advertisement/${data.id}`).then((res) => {})
      }
      if (this.targetUrl) {
        this.$router.push(this.targetUrl)
        return
      }
      // 院区banner广告埋点
      
      if(this.bannerType == '47') {
        try {
          this.hina.track('EV_HA_BANNER_CLICK',{
            adv_banner_id:data.id,
            banner_name:data.banner_name,
          })
        } catch (error) {
        }
      }
      // 医院首页banner埋点
      if(this.bannerType == '3') {
        try {
          this.hina.track('EV_HH_BANNER_CLICK',{
            adv_banner_id:data.id,
            banner_name:data.banner_name,
          })
        } catch (error) {
        }
      }
      // 跳转链接
      const from = this.$from
      location.href = data.ad_url
    },
    elementInViewport() {
      let el = this.$refs['swiper' + this.bannerType]
      let arry = el.getBoundingClientRect()
      let top = arry.top
      let left = arry.left
      let width = arry.width
      let height = arry.height
      while (el.offsetParent) {
        el = el.offsetParent
        top += el.offsetTop
        left += el.offsetLeft
      }
      return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        top + height <= window.pageYOffset + window.innerHeight &&
        left + width <= window.pageXOffset + window.innerWidth
      )
    },
    bannerChange1(index) {
      this.topBannerShow = this.elementInViewport()
      if (this.topBannerShow) {
        window.maskBaseApi.get(`/advStatistics/statistics/ViewNum?advId=${this.imgs[Number(index)].id}&type=1&index=${index}`).then((res) => {})
      }
      // console.log(this.topbanner_flge)
      // if (this.topbanner_flge >= 6) {
      //   this.bannerChange_flge = 0
      //   this.topbanner_flge = 0
      //   return
      // } else {
      //   this.topbanner_flge = 0
      // }
      // if (this.bannerChange_flge < 7) {
      //   this.bannerChange_flge = 0
      //   this.topbanner_flge = 0
      //   console.log(Number(index))
      //   console.log(this.imgs[Number(index) - 1])
      //   console.log(this.imgs[Number(index) - 1].title)
      //   window.axiosBaseApi.get(`http://192.168.1.27:8023/advStatistics/statistics/ViewNum?advId=${this.imgs[Number(index) - 1].id}&type=${this.type}`).then(res => {
      //     console.log('手动浏览请求成功')
      //   })
      // }
    },
    bannerChange2(index) {
      this.topBannerShow = this.elementInViewport()
      if (this.topBannerShow) {
        window.maskBaseApi.get(`/advStatistics/statistics/ViewNum?advId=${this.list[Number(index)].id}&type=1&index=${index}`).then((res) => {})
      }
      if(this.bannerType == '47') {
        try {
          this.hina.track('EV_HA_BANNER_SHOW',{
            adv_banner_id:this.list[Number(index)].id,
            banner_name:this.list[Number(index)].banner_name,
          })
        } catch (error) {
        }
      }
      if(this.bannerType == '3') {
        try {
          this.hina.track('EV_HH_BANNER_SHOW',{
            adv_banner_id:this.list[Number(index)].id,
            banner_name:this.list[Number(index)].banner_name,
          })
        } catch (error) {
        }
      }
    }
  },
  created() {
    if (this.list && this.list.length > 0) {
      if (this.bannerType === 1) {
        // 首页广告
        MaskBannerApis.getBanners({ type: this.bannerType }).then((res) => {
          this.imgs = res.data
          window.maskBaseApi.get(`/advStatistics/statistics/ViewNum?advId=${this.imgs[0].id}&type=1&index=0`).then((res) => {
            console.log('自动浏览请求成功')
          })
        })
      } else if (this.type === 2) {
        // 支付页广告
        window.axiosBaseApi.get(`/v1/carousel`).then((res) => {
          if (res.data.code === 1) {
            this.imgs = res.data.data
          } else {
            alert(res.data.msg)
          }
        })
      }
      // 院区首页埋点
      if(this.bannerType == '47') {
        try {
          this.hina.track('EV_HA_BANNER_SHOW',{
            adv_banner_id:this.list[Number(0)].id,
            banner_name:this.list[Number(0)].id.banner_name,
          })
        } catch (error) {
          
        }
      }
      if(this.bannerType == '3') {
        try {
          this.hina.track('EV_HH_BANNER_SHOW',{
            adv_banner_id:this.list[Number(0)].id,
            banner_name:this.list[Number(0)].id.banner_name,
          })
        } catch (error) {
          
        }
      }
    }
  },
  mounted() {
    // let vm = this
    // setInterval(function () {
    //   console.log(vm.bannerChange_flge)
    //   if (vm.bannerChange_flge === 7) {
    //     vm.bannerChange_flge = 0
    //   }
    //   vm.bannerChange_flge += 1
    //   vm.topBannerShow = vm.elementInViewport()
    //   console.log(vm.topBannerShow)
    //   if (vm.topBannerShow) {
    //     vm.topbanner_flge += 1
    //   } else {
    //     vm.topbanner_flge = 0
    //   }
    // }, 1000)
  }
}
</script>

<style lang="less">
.swiper1 {
  width: 100%;
  height: 4.56rem;
  background-color: #ccc;
  .swiper-item {
    .swiper-img {
      width: 100%;
      height: 100%;
    }
  }
}
.swiper2 {
  width: 100%;
  height: 2rem;
  background-color: #ccc;
  .swiper-item {
    .swiper-img {
      width: 100%;
      height: 100%;
    }
  }
}
.sw .mint-swipe-indicators {
  display: none;
}
</style>
